export const CLOSED = 'CLOSED' as const;
export const ACTIVE = 'ACTIVE' as const;
export const FUTURE = 'FUTURE' as const;
